if (!customElements.get('storch-shell')) {
  customElements.define('storch-shell', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mobileMenu = this.querySelector('[data-sr-mobile]');
      this.mobilePanel = this.querySelector('.sr-shell-mobile-panel');
      this.mobileTrigger = this.mobileMenu?.querySelector('summary');
      this.search = this.querySelector('[data-sr-search]');

      this.mobileMenu?.addEventListener('toggle', () => this.onMobileToggle(), { signal });
      this.querySelectorAll('[data-sr-close]').forEach(button => {
        button.addEventListener('click', () => this.closeMobile(), { signal });
      });

      this.querySelectorAll('.sr-shell-nav-disclosure').forEach(details => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          const nav = details.closest('nav');
          nav.querySelectorAll('.sr-shell-nav-disclosure[open]').forEach(other => {
            if (other !== details) other.open = false;
          });
          if (this.search) this.search.open = false;
        }, { signal });
      });

      this.search?.addEventListener('toggle', () => {
        if (!this.search.open) return;
        this.closeDisclosures();
        this.search.querySelector('input[type="search"]')?.focus();
      }, { signal });

      this.addEventListener('click', event => {
        if (event.target.closest('.sr-shell-mobile-panel a')) this.closeMobile(false);
      }, { signal });

      document.addEventListener('click', event => {
        if (!this.contains(event.target)) {
          this.closeDisclosures();
          if (this.search) this.search.open = false;
        }
      }, { signal });

      document.addEventListener('keydown', event => this.onKeydown(event), { signal });
      this.desktopMedia = window.matchMedia('(min-width: 1100px)');
      this.desktopMedia.addEventListener('change', event => {
        if (event.matches) this.closeMobile(false);
        this.closeDisclosures();
      }, { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      document.body.classList.remove('sr-shell-menu-open');
    }

    closeDisclosures() {
      this.querySelectorAll('.sr-shell-nav-disclosure[open]').forEach(details => {
        details.open = false;
      });
    }

    onMobileToggle() {
      const open = this.mobileMenu.open;
      document.body.classList.toggle('sr-shell-menu-open', open);
      if (open) {
        if (this.search) this.search.open = false;
        this.mobilePanel.querySelector('[data-sr-close]')?.focus();
      }
    }

    closeMobile(restoreFocus = true) {
      if (!this.mobileMenu?.open) return;
      this.mobileMenu.open = false;
      document.body.classList.remove('sr-shell-menu-open');
      this.closeDisclosures();
      if (restoreFocus) this.mobileTrigger?.focus();
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        const activeDisclosure = document.activeElement?.closest('.sr-shell-nav-disclosure[open]');
        if (activeDisclosure && this.contains(activeDisclosure)) {
          activeDisclosure.open = false;
          activeDisclosure.querySelector('summary')?.focus();
          event.preventDefault();
          return;
        }
        if (this.search?.open) {
          this.search.open = false;
          this.search.querySelector('summary')?.focus();
          event.preventDefault();
          return;
        }
        if (this.mobileMenu?.open) {
          this.closeMobile();
          event.preventDefault();
          return;
        }
        this.closeDisclosures();
      }

      if (event.key !== 'Tab' || !this.mobileMenu?.open) return;
      const focusable = [...this.mobilePanel.querySelectorAll('a[href], button, input, summary, [tabindex="0"]')]
        .filter(element => !element.disabled && element.getClientRects().length > 0);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first || !last) return;
      if (event.shiftKey && (document.activeElement === first || !this.mobilePanel.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !this.mobilePanel.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    }
  });
}
